import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var LabelType;
(function (LabelType) {
    LabelType["SALESFUNNEL"] = "SALESFUNNEL";
    LabelType["SALESPROMOTION"] = "SALESPROMOTION";
    LabelType["CONTACTS"] = "CONTACTS";
    LabelType["ACCOUNTS"] = "ACCOUNTS";
    LabelType["ORDERS"] = "ORDERS";
    LabelType["PRODUCT"] = "PRODUCT";
    LabelType["WEBSITES"] = "WEBSITES";
    LabelType["POST_CONTACTS"] = "POST_CONTACTS";
    LabelType["POST_ACCOUNTS"] = "POST_ACCOUNTS";
})(LabelType || (LabelType = {}));
